"use client";
import classnames from "classnames";
import { usePagination, DOTS } from "../components/usePagination";

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });


  if (!paginationRange || (paginationRange.length < 2 && !props.alwaysShow)) {
    return null;
  }

  const lastPage = paginationRange[paginationRange.length - 1];

  // Fixed handlers with proper bounds checking
  const onNext = () => {
    if (currentPage < lastPage) {
      onPageChange(currentPage + 1);
    }
  };

  const onPrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const isPreviousDisabled = currentPage === 1;
  const isNextDisabled = currentPage === lastPage;

  return (
    <ul
      style={{
        padding: "0px",
        margin: "0px",
      }}
      className={classnames("pagination-container", { [className]: className })}
    >
      {/* Previous Button */}
      <li
        className={classnames("pagination-item", {
          disabled: isPreviousDisabled,
        })}
        onClick={isPreviousDisabled ? undefined : onPrevious} // Conditional onClick
        style={{
          cursor: isPreviousDisabled ? "not-allowed" : "pointer",
          opacity: isPreviousDisabled ? 0.5 : 1,
        }}
      >
        <div
          className=""
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            color: isPreviousDisabled ? "#ccc" : "#24242E",
          }}
        >
          <span className="material-icons">keyboard_backspace</span>
          Previous
        </div>
      </li>

      {/* Page Numbers */}
      {paginationRange.map((pageNumber, index) => {
        if (pageNumber === DOTS) {
          return (
            <li className="pagination-item dots" key={`dots-${index}`}>
              &#8230;
            </li>
          );
        }

        return (
          <li
            key={pageNumber}
            className={classnames("pagination-item", {
              selected: pageNumber === currentPage,
            })}
            onClick={() => onPageChange(pageNumber)}
            style={{ cursor: "pointer" }}
          >
            {pageNumber}
          </li>
        );
      })}

      {/* Next Button */}
      <li
        className={classnames("pagination-item", {
          disabled: isNextDisabled,
        })}
        onClick={isNextDisabled ? undefined : onNext} // Conditional onClick
        style={{
          cursor: isNextDisabled ? "not-allowed" : "pointer",
          opacity: isNextDisabled ? 0.5 : 1,
        }}
      >
        <div
          className=""
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            color: isNextDisabled ? "#ccc" : "#24242E",
          }}
        >
          Next
          <span className="material-icons">east</span>
        </div>
      </li>
    </ul>
  );
};

export default Pagination;
